module.exports = __webpack_public_path__ + "static/media/synthetix.2d10cbc8.png";